import React from 'react';
import { withRouter } from 'react-router-dom';

class BaixaEstoque extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            id: 0,
            produto: "",
            embalagem: "",
            unidadeMedida: "",
            qtddEmbalagem: "",
            unidadesDisponiveis: "",
            ativo: "",
            centroId: 0,
            centro: "",
            qtdd: 0,
            usuarioId: 0
        };

        this.mais = this.mais.bind(this);
        this.menos = this.menos.bind(this);
        this.efetuarBaixa = this.efetuarBaixa.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    decimalMask(str_val) {

        let res = ""; 
        let vec = str_val.split(",");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",0";

        return res;

    }

    desformatarValor(s) {
        if (s === null) return "";
        return s.replace(",", ".");
    }

    formatarValor(s) {
        if (s === null) return ""; 
        return s.replace(".", ",");
    }

    mais() {
        this.setState({ qtdd: this.state.qtdd + 1 });
    }

    menos() {

        if (this.state.qtdd > 0) {
            this.setState({ qtdd: this.state.qtdd - 1 });
        }

    }

    efetuarBaixa() {

        this.setState({ disabled: true });

        if (this.state.unidadesDisponiveis === 0) {

            this.props.errMsgHandler("Produto indisponível no estoque.");
            this.setState({ disabled: false });

        } else if (this.state.qtdd === 0) {

            this.props.errMsgHandler("Por favor, informe a quantidade de unidades que serão removidas do estoque.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj1 = {
                "id": this.state.id,
                "produto": this.state.produto,
                "embalagem": this.state.embalagem,
                "unidade_medida": this.state.unidadeMedida,
                "qtdd_embalagem": this.desformatarValor(this.state.qtddEmbalagem),
                "unidades_disponiveis": this.state.unidadesDisponiveis - this.state.qtdd,
                "ativo": this.state.ativo,
                "centro_id": this.state.centroId
            };

            let obj2 = {
                "fluxo": (-this.state.qtdd),
                "unidades_disponiveis": this.state.unidadesDisponiveis - this.state.qtdd,
                "estoque_id": this.state.id,
                "usuario_id": this.state.usuarioId
            };

            fetch("/api/estoque/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj1)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    fetch("/api/fluxo_estoque/", {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                            "Authorization": "Basic " + btoa(localStorage.auth)
                        },
                        mode: "cors",
                        body: JSON.stringify(obj2)
                    })
                    .then(response2 => response2.json())
                    .then(responseJson2 => {

                        if (responseJson2.msg === "success") {

                            this.props.waitMsgHandler("");
                            this.props.successMsgHandler("Baixa efetuada com sucesso.");

                            let obj3 = {
                                row: {
                                    id: this.state.id,
                                    data: [
                                        this.state.produto,
                                        this.state.embalagem,
                                        this.state.unidadeMedida,
                                        this.state.qtddEmbalagem,
                                        this.state.unidadesDisponiveis - this.state.qtdd,
                                        this.state.ativo
                                    ]
                                }
                            };

                            this.props.history.push({
                                pathname: "/visualizarproduto",
                                state: obj3
                            });

                        }

                    });

                }

            });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: [
                    this.state.produto,
                    this.state.embalagem,
                    this.state.unidadeMedida,
                    this.state.qtddEmbalagem,
                    this.state.unidadesDisponiveis,
                    this.state.ativo
                ]
            }
        };

        this.props.history.push({
            pathname: "/visualizarproduto",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque !== "escrever"
            && localStorage.roleEstoque !== "baixa") {

            window.location.href = "/home";

        }

        if (this.props.location.state === undefined) {
            window.location.href = "/visualizarproduto";
        }

        let uId = JSON.parse(localStorage.usuarioInfo).id;

        let id = this.props.location.state.id;
        let produto = this.props.location.state.produto;
        let embalagem = this.props.location.state.embalagem;
        let unidadeMedida = this.props.location.state.unidadeMedida;
        let qtddEmbalagem = this.props.location.state.qtddEmbalagem;
        let unidadesDisponiveis = this.props.location.state.unidadesDisponiveis;
        let ativo = this.props.location.state.ativo;
        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;

        this.setState({ id: id });
        this.setState({ produto: produto });
        this.setState({ embalagem: embalagem });
        this.setState({ unidadeMedida: unidadeMedida });
        this.setState({ qtddEmbalagem: qtddEmbalagem });
        this.setState({ unidadesDisponiveis: unidadesDisponiveis });
        this.setState({ centroId: centroId });
        this.setState({ centro: centro });
        this.setState({ usuarioId: uId });

        if (ativo === 0) {
            this.setState({ ativo: false });
        } else {
            this.setState({ ativo: true });
        }

    }

    render() {
        return(
            <div>
                <h1 id="baixa-estoque-title">Baixa no Estoque</h1><br /><br />
                <p id="baixa-estoque-txt">
                    <b>Centro:</b> { this.state.centro }
                </p><br />
                <p id="baixa-estoque-txt">
                    <b>Produto: </b>
                    { this.state.produto }
                    { " (" }
                    { this.state.embalagem }
                    { " de " }
                    { this.decimalMask(this.state.qtddEmbalagem) }
                    { " " }
                    { this.state.unidadeMedida }
                    { ")" }
                </p><br />
                <p id="baixa-estoque-txt">
                    <b>Unidades Disponíveis: </b>
                    { this.state.unidadesDisponiveis }
                    { " (" }
                    { this.decimalMask(this.formatarValor(parseFloat(
                        this.desformatarValor(this.state.qtddEmbalagem) * this.state.unidadesDisponiveis).toString())) }
                    { " " }
                    { this.state.unidadeMedida }
                    { ")" }
                </p><br /><br />
                <form id="baixa-estoque-form">
                    <p id="baixa-estoque-txt">
                        <b>Informe a quantidade de unidades que serão removidas estoque:</b>
                    </p><br />
                    <input type="text"
                        value={ this.state.qtdd } />
                    <button type="button"
                        id="baixa-estoque-qtdd-btn"
                        onClick={ this.menos }>
                        -
                    </button>
                    <button type="button"
                        id="baixa-estoque-qtdd-btn"
                        onClick={ this.mais }>
                        +
                    </button>
                    <br />
                    <button type="button"
                        id="baixa-estoque-efetuar-btn"
                        Class="baixa-estoque-efetuar-btn"
                        onClick={ this.efetuarBaixa }
                        disabled={ this.state.disabled }>
                        Efetuar Baixa
                    </button>
                    <button type="button"
                        id="baixa-estoque-cancelar-btn"
                        onClick={ this.cancelar }>
                        Cancelar
                    </button>
                </form>
            </div>
        );
    }

}

export default withRouter(BaixaEstoque);

